<script>
  import { format } from 'svelte-i18n';
  import { Button, ButtonGroup } from '@sveltestrap/sveltestrap';

  import { CodeMirror } from '@client/components/codemirror';
  import { SectionItem } from '@client/components/section';

  import { appStore } from '@client/stores/app';
  import { syncConnections } from '@client/stores/sync-connections';

  export let html = '';
  export let preserveUnknown = true;

  $: hasFront = $syncConnections.checkfrontappconnected;
  $: hasOutreach = $syncConnections.checkoutreachconnected;
  $: showMergeOptions = hasFront || hasOutreach;
</script>

{#if showMergeOptions}
  <SectionItem
    label={$format('label.MERGE_FIELDS')}
    tooltip={$format('label.TOOLTIP.MERGE_FIELDS')}
    description={$format(preserveUnknown ? 'label.DESCRIPTION.MERGE_FIELDS' : 'label.DESCRIPTION.MERGE_FIELDS_REMOVE')}
  >
    <div class="text-right">
      <ButtonGroup>
        <Button active={preserveUnknown} on:click={() => (preserveUnknown = true)} data-testid="preserve">
          {$format('label.PRESERVE')}
        </Button>
        <Button active={!preserveUnknown} on:click={() => (preserveUnknown = false)} data-testid="remove">
          {$format('label.REMOVE')}
        </Button>
      </ButtonGroup>
    </div>
  </SectionItem>
{/if}

<SectionItem borderless fill label={$format('label.HTML')}>
  <div class="editor">
    <CodeMirror bind:value={html} disableFormatting lineWrapping={$appStore.mobile} />
  </div>
</SectionItem>
